import { AxiosPromise } from 'axios';
import axios from 'axios';
import { IBannerParams, IGetBanner, IGetBanners } from '../models/banner.model';
import QueryString from 'qs';

const uri = '/mgmt/banner';

export const getBanner = (bannerCode: number): AxiosPromise<IGetBanner> => {
  return axios.get(`${uri}/${bannerCode}`);
};

export const getBanners = (params: IBannerParams): AxiosPromise<IGetBanners> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}?${qsParams}`);
};

export const createBanner = (data: FormData): AxiosPromise => {
  return axios.post(uri, data);
};

export const updateBanner = (bannerCode: number, data: FormData): AxiosPromise => {
  return axios.put(`${uri}/${bannerCode}`, data);
};

export const deleteBanner = (bannerCode: number): AxiosPromise => {
  return axios.delete(`${uri}/${bannerCode}`);
};
